import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ProyectoAlcanceTerritorialDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ProyectoAlcanceTerritorialService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private readonly http: HttpClient) {}

  getProyectoAlcanceTerritorialService(): Observable<
    BodyListResponse<ProyectoAlcanceTerritorialDTO>
  > {
    return this.http.get<BodyListResponse<ProyectoAlcanceTerritorialDTO>>(
      API_URL + '/api/v1/proyectoAlcanceTerritorial/todos',
    );
  }

  guardarProyectoAlcanceTerritorialService(
    proyectoAlcanceTerritorialDTO: ProyectoAlcanceTerritorialDTO,
  ): Observable<BodyResponse<ProyectoAlcanceTerritorialDTO>> {
    return this.http.post<BodyResponse<ProyectoAlcanceTerritorialDTO>>(
      API_URL + '/api/v1/proyectoAlcanceTerritorial',
      proyectoAlcanceTerritorialDTO,
    );
  }

  getProyectoAlcanceTerritorialPorCodigoService(
    codigo: string,
  ): Observable<BodyResponse<ProyectoAlcanceTerritorialDTO>> {
    return this.http.get<BodyResponse<ProyectoAlcanceTerritorialDTO>>(
      API_URL + '/api/v1/proyectoAlcanceTerritorial/' + codigo,
    );
  }
}
